export enum TimelineTypeEnum {
  ATTENDANCE = "ATTENDANCE",
  OPPORTUNITY = "OPPORTUNITY",
}

export enum TimelineActionEnum {
  CREATE = "CREATE",
  STATUS = "STATUS",
  ASSIGN = "ASSIGN",
  TRANSFER = "TRANSFER",
  CLOSE = "CLOSE",
  DELETE = "DELETE",
  UPDATE = "UPDATE",
  STAGE = "STAGE",
  WON = "WON",
  LOSE = "LOSE",
  TAG_ADDED = "TAG_ADDED",
  TAG_REMOVED = "TAG_REMOVED",
  CAMPAIGN_ORIGIN = "CAMPAIGN_ORIGIN",
}
